import React, { useState } from "react"

import {
    defaultUom as _defaultUom,
    itemUoms as _itemUoms,
    validateSchema as _validateItemSchema,
    initialValues as _initialItemValues,
    customInjectionProps as _customInjectionProps,
    customInjectionFields as _customInjectionFields
} from "../../schema/items/itemSchema"

// import {
//     useInjectionProps,
//     propTypes as injectionPropTypes,
//     targetTypes as injectionPropTargetTypes,
// } from "../../../../hooks/api/useInjectionProps"

import {
    useInjectionFields,
    getUpdateFieldValuesPayload,
    scopeTypes as injectionFieldScopeTypes,
} from "../../../../hooks/api/useInjectionFields"

// import {
//     // getUniqueItemCode as _getUniqueItemCode,
//     createProductItemInjectionPropsPayload,
// } from "../../utils/injectionProps"

// import { useProduct, productInjectionFields, productLoadStatusTypes } from "./useProduct"
import { useContainerSummary } from "./useContainerSummary"

import {
    getUniqueItemCode as _getUniqueItemCode,
    createProductItemInjectionFieldsPayload,
    // createContainerInjectionFieldsPayload
} from "../../utils/injectionFields"

import {
    useSchedulers,
    schedulerConfigs,
    schedulerTypes,
    targetTypes as schedulerTargetTypes,
    schedulerModules,
    schedulerRefs,
    schedulerTargets
} from "../../../../hooks/api/useSchedulers"

import { useItems, itemTypes, targetTypes as itemTargetTypes } from "../../../../hooks/api/useItems"

import { getInjectionDataType } from "../../utils/injectionSelection"

export const itemUoms = _itemUoms
export const getUniqueItemCode = _getUniqueItemCode
export const defaultUom = _defaultUom
export const itemInjectionProps = _customInjectionProps
export const itemInjectionFields = _customInjectionFields
export const validateSchema = _validateItemSchema
export const initialValues = _initialItemValues

export function useProductItem({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    // const {
    //     create: createInjectionProps
    // } = useInjectionProps({ propType: injectionPropTypes.item.product.id, targetType: injectionPropTargetTypes.item.id })

    const { updateFieldValues } = useInjectionFields({
        scopeType: injectionFieldScopeTypes.item.id
    });

    const { get, list, remove, update, createBatch, createBatchProps, filterOperatorTypes } = useItems({ itemType: itemTypes.item, targetType: itemTargetTypes.item });

    // const { getProduct, listProducts } = useProduct({ routeType })
    const { updateContainerSummary } = useContainerSummary({ routeType })

    const {
        create: createSchedulerRequest
    } = useSchedulers({ schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })

    // private
    const fetchItem = async ({ itemId }) => {

        try {

            let dataTypesArray = [`${getInjectionDataType('item')}`]

            const data = await getProductItem({ id: itemId, itemType: itemTypes.item, dataTypesArray })

            return data

        } catch (error) {

            return {}

        }

    }

    // list items
    const listProductItems = async ({
        props,
        itemIds = [],
        productIds = [],
        productIdFrom = 0,
        productIdTo = 0,
        dataTypes = [`${getInjectionDataType('item')}`]
    }) => {

        props.dataTypes = dataTypes

        let filterValues = [
        ]

        if (productIds.length > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: `product_id`,
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(productIds),
                },
            ]]
        }

        if (productIdFrom > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: `product_id`,
                    operator: filterOperatorTypes.moreThanEq,
                    value: productIdFrom
                },
            ]]
        }

        if (productIdTo > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: `product_id`,
                    operator: filterOperatorTypes.lessThanEq,
                    value: productIdTo
                },
            ]]
        }

        if (itemIds.length > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: "id",
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(itemIds)
                },
            ]]
        }

        if (props?.filterValue) {
            props.filterValue = [...props.filterValue, ...filterValues]
        } else {
            props.filterValue = filterValues
        }

        const result = await list(props)

        let data = result?.data?.items ? result.data.items : []

        return {
            data,
            // count: result?.data?.nofilter_total
            count: result?.data?.total
        }

    }

    // done
    // update the product item - currently only update the injection props
    const updateProductItem = async ({
        itemId: _itemId = '',
        productId: _productId = '',
        sourceItemRemId: _sourceItemRemId = '',
        registerLocationId: _registerLocationId = '',
        item: _item = {
            userMarking: "",
            userBranchId: "",
            userId: "",
            code: "",
            uomId: "",
            itemDescription: "",
            remark: "",
            uomPrice: 0,
            netWeight: 0,
            width: 0,
            height: 0,
            length: 0,

            qty: 0,
            handleQty: 0,
            handleQtyPerPackage: 0,
            uomName: "",

            cbm: 0,
            totalWeight: 0,
            totalValue: 0,
            totalCbm: 0
        },
        skipTargetInjectionPropIds: _skipTargetInjectionPropIds = [
            `containerId`,
            `customerBranchId`,
            `customerUserId`,
            `locationId`,
            `customerMarking`,
            `sourceItemRemId`,
        ],
        targetInjectionPropIds: _targetInjectionPropIds = []
    }) => {

        if (!_sourceItemRemId) {
            throw Error("Source Item RemId is empty")
        }

        let _skipTargetInjectionFieldIds = _skipTargetInjectionPropIds
        let _targetInjectionFieldIds = _targetInjectionPropIds

        let data1 = {
            item: {
                code: _item.code,
                uom_id: _item.uomId,
                item_description: _item.itemDescription,
                remark: _item.remark,
                cost: 0,
                uom_price: _item.uomPrice,
                floor_price: 0,
                gross_weight: 0,
                volume_weight: 0,
                net_weight: _item.netWeight,
                dimension_width: _item.width,
                dimension_height: _item.height,
                dimension_length: _item.length,
                cbm: _item.cbm,
                is_package: 0,
                status: 1,
            }
        }
        // console.log('data1', data1)

        let response1 = await update({
            id: _itemId,
            data: data1,
            targetType: itemTargetTypes.item,
            skipSchedulerRequestSubmit: true
        })

        // console.log('response1', response1)

        // for injection fields
        let b = createProductItemInjectionFieldsPayload({
            itemId: _itemId,
            data: {
                input: _item
            },
            mainData: {
                marking: _item?.userMarking,
                userBranchId: _item?.userBranchId,
                userId: _item?.userId
            },
            skipTargetInjectionFieldIds: _skipTargetInjectionFieldIds,
            targetInjectionFieldIds: _targetInjectionFieldIds
        })

        // for injection fields
        const response3 = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: b }), overrideScopeType: injectionFieldScopeTypes.item.id });

        // check this item is loaded
        // let currentProduct = await getProduct({ id: _productId })

        // let currentProductLoadContainerStatus = currentProduct?.product[productInjectionFields.loadStatus.retrieveKey]
        // let currentProductLoadContainerId = currentProduct?.product[productInjectionFields.loadContainerId.retrieveKey]

        // console.log('currentProductLoadContainerStatus', currentProductLoadContainerStatus)
        // console.log('currentProductLoadContainerId', currentProductLoadContainerId)

        // if (
        //     productLoadStatusTypes.loaded.id === currentProductLoadContainerStatus
        //     &&
        //     currentProductLoadContainerId
        // ) {
        //     // calculate the current container summary
        //     let containerSummary = await updateContainerSummary({ containerId: currentProductLoadContainerId, listProducts })
        //     // let {
        //     //     totalCbm,
        //     //     totalPackQty,
        //     //     totalWeight,
        //     //     totalValue
        //     // } = containerSummary

        //     // console.log('containerSummary', containerSummary)

        //     // // append inj fields - for container info
        //     // let injectionFieldsContainer = createContainerInjectionFieldsPayload({
        //     //     containerId: currentProductLoadContainerId,
        //     //     data: {
        //     //         totalCbm,
        //     //         totalValue,
        //     //         totalPackQty,
        //     //         totalWeight
        //     //     },
        //     //     targetInjectionFieldIds: [
        //     //         `totalCbm`,
        //     //         `totalValue`,
        //     //         `totalPackQty`,
        //     //         `totalWeight`,
        //     //     ],
        //     // })

        //     // // injection fields
        //     // await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsContainer }), overrideScopeType: injectionFieldScopeTypes.repository.id })

        // }

        // add the scheduler requests
        // console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)

        if (
            schedulerConfigs?.schedulerIntegrationIds &&
            schedulerConfigs?.schedulerIntegrationIds.length > 0
        ) {

            let currentItem = await fetchItem({ itemId: _itemId })

            // console.log('currentItem', currentItem)

            let dataSchedulerRequest = {
                scheduler_request: {
                    source_id: _itemId,
                    target: schedulerTargets.request.item,
                    module: schedulerModules.request.item.item,
                    request_ref: schedulerRefs.request.item.item,
                    integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                    destination_id: currentItem[itemInjectionProps.sourceItemRemId.retrieveKey],
                    action: 'update',
                    source_data:
                        JSON.stringify({
                            ...currentItem,
                            sourceItemRemId: _sourceItemRemId,
                            registerLocationId: _registerLocationId,
                        })
                }
            }

            // console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

            // create scheduler request
            let b = await createSchedulerRequest({
                data: dataSchedulerRequest,
                schedulerType: schedulerTypes.schedulerRequest,
                targetType: schedulerTargetTypes.schedulerRequest
            })

        }

        return response1

    }

    // get product item
    const getProductItem = async ({ id, dataTypesArray = [`${getInjectionDataType('item')}`] }) => {

        const result = await get({ id, dataTypesArray })

        let data = result?.data ? result.data : {}

        return data

    }

    // done
    // create batch product item
    const addProductItemBatch = async ({
        onlyCreateData: _onlyCreateData = false,
        sourceProductRemId: _sourceProductRemId = "",
        registerLocationId: _registerLocationId = "",
        customerMarking: _customerMarking = "",
        customerBranchId: _customerBranchId = "",
        customerUserId: _customerUserId = "",
        // array
        data: _data = [{
            productId: "",
            code: "",
            uomId: "",
            uomName: "",
            customUomName: "", // optional to put into the injection field
            uomPrice: 0,
            remark: "",
            netWeight: 0,
            itemDescription: "",
            width: 0,
            height: 0,
            length: 0,
            cbm: 0,
            // for injection props
            qty: 0,
            handleQty: 0,
            handleQtyPerPackage: 0,
            totalValue: 0,
            totalCbm: 0,
            totalWeight: 0,
        }],
        skipTargetInjectionPropIds: _skipTargetInjectionPropIds = [
            `sourceItemRemId`,
        ]
    }) => {

        let _skipTargetInjectionFieldIds = _skipTargetInjectionPropIds

        let targetType = itemTargetTypes.item

        let data = _data.map(i => {
            return {
                product_id: i.productId,
                code: i.code,
                uom_id: i.uomId,
                cost: 0,
                uom_price: i.uomPrice,
                floor_price: 0,
                remark: i.remark,
                gross_weight: 0,
                net_weight: i.netWeight,
                volume_weight: 0,
                item_description: i.itemDescription,
                dimension_width: i.width,
                dimension_height: i.height,
                dimension_length: i.length,
                cbm: i.cbm,
                status: 1,
                is_package: 0
            }
        })

        // console.log('data', data, _data)

        let result = await createBatch({
            data: {
                item: data
            },
            targetType
        })

        // console.log('result', result)

        let response = result?.data?.items ? result.data.items : []

        // if only create batch data return the response here
        if (_onlyCreateData === true) {
            return response
        }

        let addedItems = response

        // let _injectionProps = []
        let _injectionFields = []

        addedItems.forEach((i2, index2) => {

            // let a = {}
            let b = []
            let _newItemId = i2?.id

            // let valuesItems = items[index2]
            let _valuesItems = _data.filter(i5 => i5.code === i2.code)
            let valuesItems = _valuesItems.length > 0 ? _valuesItems[0] : {}

            // console.log('_valuesItems', _valuesItems)

            if (_newItemId) {

                // only save the injection fields
                b = createProductItemInjectionFieldsPayload({
                    itemId: _newItemId,
                    data: {
                        input: {
                            uomName: valuesItems?.customUomName ? valuesItems.customUomName : valuesItems?.uomName,
                            qty: parseFloat(valuesItems?.qty).toFixed(0),
                            // Not rounded: totalValue below was worked out from this exact qty.
                            handleQty: parseFloat(valuesItems?.handleQty).toFixed(4),
                            handleQtyPerPackage: parseFloat(valuesItems?.handleQtyPerPackage).toFixed(0),
                            totalValue: parseFloat(valuesItems?.totalValue).toFixed(2),
                            totalCbm: parseFloat(valuesItems?.totalCbm).toFixed(4),
                            totalWeight: parseFloat(valuesItems?.totalWeight).toFixed(4),
                        }
                    },
                    mainData: {
                        marking: _customerMarking,
                        userBranchId: _customerBranchId,
                        userId: _customerUserId
                    },
                    skipTargetInjectionFieldIds: _skipTargetInjectionFieldIds
                })

                // _injectionProps = [..._injectionProps, ...a]
                _injectionFields = [..._injectionFields, ...b]

            }
        })

        // injection fields
        let responseInjectionFields = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: _injectionFields }), overrideScopeType: injectionFieldScopeTypes.item.id });

        let itemIds = addedItems.map(i5 => i5?.id)
        // let relatedItems = await fetchItems({ itemIds })

        let props = {
            limit: -1,
            skip: 0,
            filterValue: [],
            sortInfo: {
                id: "id",
                dir: 0
            }
        }

        let { data: relatedItems } = await listProductItems({ props, itemIds, dataTypes: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`] })

        // let promises = []

        let allResSchedulers = await Promise.all(

            // Use map to create an array of promises,  
            // with one promise for each item in myArray. 
            // myArray.map(async item => {
            addedItems.map(async (i2) => {

                let newItemId = i2?.id
                let search = relatedItems.filter(i5 => i5?.id === newItemId)

                let currentItem = search.length > 0 ? search[0] : {}

                let dataSchedulerRequest = {
                    scheduler_request: {
                        source_id: newItemId,
                        target: schedulerTargets.request.item,
                        module: schedulerModules.request.item.item,
                        request_ref: schedulerRefs.request.item.item,
                        integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                        destination_id: "",
                        action: 'create',
                        source_data:
                            JSON.stringify({
                                item: {
                                    ...currentItem
                                },
                                sourceProductRemId: _sourceProductRemId,
                                registerLocationId: _registerLocationId,
                            })
                    }
                }

                // console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

                // create scheduler request
                let res = await createSchedulerRequest({
                    data: dataSchedulerRequest,
                    schedulerType: schedulerTypes.schedulerRequest,
                    targetType: schedulerTargetTypes.schedulerRequest
                })

                return res

            })

            // })
        );

        return response
    }

    // create batch product item props
    const addProductItemPropsBatch = async ({ data }) => {

        let targetType = itemTargetTypes.item

        let result = await createBatchProps({ data, targetType })

        let response = result?.data?.items ? result.data.items : []

        return response
    }

    // remove product items
    const removeProductItems = async ({ ids }) => {

        const result = await remove({ ids })

        // let data = result?.data ? result.data : {}

        return result

    }

    return {
        filterOperatorTypes,
        listProductItems,
        updateProductItem,
        getProductItem,
        addProductItemBatch,
        addProductItemPropsBatch,
        removeProductItems
    }
}